import { useSearchParams } from 'react-router-dom';

import {
  ADD_CONTRACT_PARAM,
  ADD_CONTRACT_CHANNEL_ID_PARAM,
  ADD_CONTRACT_CHANNEL_NAME_PARAM,
  OAUTH_CALLBACK_HASH_PARAM,
} from './use-add-contract-search-params';

export function useIndeedPanelParams() {
  const [params, setParams] = useSearchParams();
  return {
    isOpen: params.get('indeed_panel') === '1',
    isOrganic: params.get('indeed_organic') === '1',
    open: ({ organic = false }: { organic?: boolean } = {}) => {
      setParams(
        previous => {
          const next = new URLSearchParams(previous);
          next.set('indeed_panel', '1');
          next.delete(ADD_CONTRACT_PARAM);
          next.delete(ADD_CONTRACT_CHANNEL_ID_PARAM);
          next.delete(ADD_CONTRACT_CHANNEL_NAME_PARAM);
          next.delete(OAUTH_CALLBACK_HASH_PARAM);
          if (organic) next.set('indeed_organic', '1');
          else next.delete('indeed_organic');
          return next;
        },
        { replace: true },
      );
    },
    close: () => {
      setParams(
        previous => {
          const next = new URLSearchParams(previous);
          next.delete('indeed_panel');
          next.delete('indeed_organic');
          return next;
        },
        { replace: true },
      );
    },
  };
}
